import axios from '@/main/axios.js'
import { messaging } from '@/libs/firebase'

export default {
  namespaced: true,
  state: {
    needsFcmSubscription: false,
    fcmToken: null,
    lastChecked: null
  },
  mutations: {
    SET_NEEDS_FCM_SUBSCRIPTION (state, value) {
      state.needsFcmSubscription = value
      state.lastChecked = new Date().toISOString()
    },
    SET_FCM_TOKEN (state, token) {
      state.fcmToken = token
    }
  },
  actions: {
    async fetchAdminInfo ({ commit }) {
      try {
        const response = await axios.get('/api/admin-system/admin-info')
        const isNeedFCMSubscription = response.data.needs_fcm_subscription
        const fcmTokens = response.data.fcm_tokens || []

        commit('SET_NEEDS_FCM_SUBSCRIPTION', isNeedFCMSubscription)

        // Check if notification permission is granted
        if (Notification.permission === 'granted' && messaging) {
          try {
            // Register the service worker
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')

            // Get the FCM token for current browser
            const currentToken = await messaging.getToken({
              vapidKey: process.env.VUE_APP_FIREBASE_PAIR_KEY,
              serviceWorkerRegistration: registration
            })

            // Check if current token exists in the fcm_tokens array
            if (fcmTokens.includes(currentToken)) {
              // Token is registered in backend, save to localStorage and store
              localStorage.setItem('fcm_token', currentToken)
              commit('SET_FCM_TOKEN', currentToken)
            } else {
              // Token not found in backend, remove from localStorage and store
              localStorage.removeItem('fcm_token')
              commit('SET_FCM_TOKEN', null)
            }
          } catch (error) {
            console.error('Failed to check FCM token:', error)
            // If error occurs, remove localStorage and store to be safe
            localStorage.removeItem('fcm_token')
            commit('SET_FCM_TOKEN', null)
          }
        } else {
          // Permission not granted or messaging not supported, remove localStorage and store
          localStorage.removeItem('fcm_token')
          commit('SET_FCM_TOKEN', null)
        }
      } catch (error) {
        console.error('Failed to fetch admin info:', error)
      }
    }
  },
  getters: {
    needsFcmSubscription: state => state.needsFcmSubscription,
    fcmToken: state => state.fcmToken,
    isSubscribed: state => !!state.fcmToken,
    lastChecked: state => state.lastChecked
  }
}